import AWS from "aws-sdk";

const BaseUrl_Employee = {
  BASE_URL: process.env.REACT_APP_API_URL_EMPLOYEE,
  BASE_URL_PYTHON: process.env.REACT_APP_API_URL_PYTHON_EMPLOYEE
};
const BaseUrl_Worker = {
  BASE_URL_PYTHON: process.env.REACT_APP_API_URL_PYTHON_WORKER,
  BASE_URL: process.env.REACT_APP_API_URL_WORKER
};

const Cloudinary = {
  CLOUDINARY_API: process.env.REACT_APP_CLOUDINARY_API_URL,
  CLOUDINARY_VIDEO_API:
    process.env.REACT_APP_CLOUDINARY_VIDEO_API_URL,
  CLOUD_NAME: process.env.REACT_APP_CLOUD_NAME,
  QUERY_PRESET: process.env.REACT_APP_CLOUDINARY_QUERY_PRESET,
  NOTICE_PRESET: process.env.REACT_APP_CLOUDINARY_NOTICE_PRESET,
  DPR_PRESET: process.env.REACT_APP_CLOUDINARY_DPR_PRESET,
  REGISTER_FACE_PRESET:
    process.env.REACT_APP_CLOUDINARY_REGISTER_FACE_PRESET
};

const AWS_KEYS = {
  s3Bucket: process.env.REACT_APP_S3_BUCKET,
  s3Region: process.env.REACT_APP_S3_REGION,
  accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_HERE,
  secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY_HERE
};

const PUSHER = {
  appKey: process.env.REACT_APP_PUSHER_APP_KEY,
  appCluster: process.env.REACT_APP_PUSHER_CLUSTER
};

AWS.config.update({
  accessKeyId: AWS_KEYS.accessKeyId,
  secretAccessKey: AWS_KEYS.secretAccessKey
});
const myBucket = new AWS.S3({
  params: { Bucket: AWS_KEYS.s3Bucket },
  region: AWS_KEYS.s3Region
});

const Auth_Api = {
  LOGIN_API: "/api/auth/login",
  CHANGE_PASSWORD_API: "/api/auth/change_password",
  RESET_PASSWORD_API: "/api/auth/reset-password",
  LOGOUT_API: "/api/auth/logout",
  REGISTER_EXCEL_API: "/api/auth/register-user-csv",
  CHECK_SESSION_API: "/api/auth/session",
  CHANGE_SESSION_STATUS_API: "/api/auth/change-session-status",
  ADD_UPDATES_API: "/api/auth/app/add-updates",
  ALL_UPDATES_API: "/api/auth/app/updates"
};

const Users_Api = {
  USER_PHOTO_REGISTER_API: "/api/users/photo-register",
  USER_REGISTER_API: "/api/users/user-register",
  GET_ALL_USERS_API: "/api/users/all-users",
  GET_ALL_USERS_IMAGES_API: "/api/users/all-users-images",
  GET_ALL_USERS_FILTER_API: "/api/users/filter",
  USER_CSV_REGISTER_API: "/api/users/user-csv-register",
  USER_RESET_PASSWORD_API: "/api/users/reset-password",
  USER_GEO_FENCE_API: "/api/users/geoFence",
  GET_USER_DETAIL_API: "/api/users",
  GET_ALL_AWS_USERS_API: "/api/users/aws",
  CHANGE_PASSWORD_API: "/api/auth/change-password",
  GET_USER_CALENDAR_DATA_API: "/api/users/calendarData",
  DELETE_USER_API: "/api/users/changeActive",
  DELETE_FACE_API: "/api/users/delete-face",
  USER_GEO_REST_ACTIVE_API: "/api/users/user-action",
  ASSIGN_RULE_TO_USER_API: "/api/users/user-action/assign-rule",
  ADD_DEVICE_API: "/api/auth/add-devices",
  GET_DEVICE_API: "/api/auth/all-devices",
  DELETE_DEVICE_API: "/api/auth/delete-devices",
  SHIFT_CHANGE_API: "/api/users/shift-change",
  ADD_LOCATION_TO_USER_API: "/api/users/change-or-shift-user-location"
};

const Rules_Api = {
  CREATE_RULES_API: "/api/rule/create",
  GET_RULES_API: "/api/rule/all-rules",
  RULE_ACTIVATE_API: "/api/rule/activate",
  RULE_DELETE_API: "/api/rule/delete"
};
const Location_Api = {
  CREATE_LOCATIONS_API: "/api/location/create-locations",
  GET_LOCATIONS_API: "/api/location/all-locations"
};

const Attendance_Api = {
  GET_DAILY_ATTENDANCE_API: "/api/attendance/daily",
  GET_DAILY_DEPARTMENT_ATTENDANCE_API:
    "/api/attendance/daily-department-wise",
  GET_ATTENDANCE_SHEET_API: "/api/attendance/attendance-sheet",
  GET_ATTENDANCE_DYNAMIC_SHEET_API:
    "/api/attendance/dynamic/attendance-sheet",
  GET_SHIFT_SHEET_API: "/api/attendance/shift-sheet",
  UPDATE_SHIFT_SHEET_API: "/api/attendance/update-shift-sheet",
  ADD_DAILY_MISSING_ATTENDANCE_API:
    "/api/attendance/add-daily-missing-attendance"
};

const Canteen_Api = {
  GET_DAILY_CANTEEN_API: "/api/canteen/daily",
  GET_CANTEEN_SHEET_API: "/api/canteen/canteen-sheet",
  CREATE_CANTEEN_RULES_API: "/api/canteen/create-canteen-rule",
  GET_CANTEEN_RULES_API: "/api/canteen/all-canteen-rules"
};

const Dashboard_Api = {
  GET_DAILY_ATT_DASHBOARD_API: "/api/dashboard/todaysData",
  GET_DAILY_GOOGLE_MAP_API: "/api/attendance/geo-data"
};
const Access_Api = {
  GET_ALL_ACCESS_API: "/api/access/all-access",
  ADD_ACCESS_API: "/api/access/add-access",
  DELETE_ACCESS_API: "/api/access/delete-access",
  GET_EMPLOYEE_ACCESS_API: "/api/access/my-access",
  GET_ALL_USERS_FOR_ACCESS_API: "/api/access/all-users"
};

const Holiday_Api = {
  ADD_HOLIDAY_LIST: "/api/holiday/add-holiday"
};
const Hr_Api = {
  GET_ALL_REIMBURSEMENT_API: "/api/hr/reimbursement/month-wise",
  ALL_MISSING_ATTENDANCE_API:
    "/api/hr/missing/all-missing-attendance",
  HANDLE_REIMBURSEMENT: "/api/hr/reimbursement/handleReimbursement",
  GET_DESIGNATION_API: "/api/hr/all-designation",
  GET_DEPARTMENT_API: "/api/hr/all-department",
  ADD_DEPARTMENT_DESIGNATION_API:
    "/api/hr/add-department-designation",
  GET_REPORTING_MANAGERS_API: "/api/hr/reporting-managers",
  ADD_REPORTING_MANAGERS_API: "/api/hr/add-reporting-manager",

  // --------------------------------
  GET_ALL_LEAVE_API: "/api/leave/all-leaves",
  APPLY_LEAVE_API: "/api/leave/apply-edit-leave",
  MY_LEAVE_API: "/api/leave/my-applied-leave",
  GET_LEAVE_TYPE_API: "/api/leave/all-leave-type",
  TAKE_LEAVE_ACTION_API: "/api/leave/change-status",
  TAKE_ATTENDANCE_ACTION_API:
    "/api/attendance/regularized-attendance",

  // zone
  GET_ZONE_API: "/api/hr/all-zone"
};
const Relation_Api = {
  GET_REPORTING_EMPLOYEES_BY_LOCATION_ID_API:
    "/api/reports/reporting-employees",
  GET_REPORTING_MANAGERS_API: "/api/reports/employee-relations",
  GET_ATTENDANCE_SHEET_REPORTS_API:
    "/api/reports/employee-attendance-report"
};
const Query_Api = {
  ADD_QUERY_API: "/api/queries/add-queries",
  GET_ALL_QUERIES_API: "/api/queries/all-queries",
  GET_QUERY_DETAILS_API: "/api/queries/query-details",
  ADD_QUERY_COMMENT_API: "/api/queries/add-comments"
};

const Dpr_Api = {
  ADD_EDIT_DPR_API: "/api/dpr/add-dpr",
  GET_ALL_DPR_API: "/api/dpr/all-dpr",
  GET_DPR_DETAILS_API: "/api/dpr/dpr-detail"
};

export {
  Hr_Api,
  Dpr_Api,
  PUSHER,
  AWS_KEYS,
  myBucket,
  Auth_Api,
  Query_Api,
  Rules_Api,
  Users_Api,
  Access_Api,
  Cloudinary,
  Canteen_Api,
  Holiday_Api,
  Location_Api,
  Relation_Api,
  Dashboard_Api,
  Attendance_Api,
  BaseUrl_Worker,
  BaseUrl_Employee
};
